import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Trash2 } from "lucide-react";
import { api, formatINR } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useCart } from "@/context/CartContext";
import { toast } from "sonner";

const Wishlist = () => {
  const { customer } = useAuth();
  const { addItem } = useCart();
  const [items, setItems] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!customer) { navigate("/"); return; }
    api.get("/wishlist").then(r => setItems(r.data)).catch(() => {});
  }, [customer, navigate]);

  const remove = async (pid) => {
    try {
      await api.delete(`/wishlist/${pid}`);
      setItems(items.filter(i => i.id !== pid));
      toast.success("Removed from wishlist");
    } catch { toast.error("Could not remove"); }
  };

  if (!customer) return null;

  return (
    <div className="rieave-container py-12 md:py-16" data-testid="wishlist-page">
      <p className="eyebrow mb-2">Wishlist</p>
      <h1 className="font-hero text-4xl md:text-5xl mb-10">Your <span className="serif-italic text-rose">saved pieces.</span></h1>
      {items.length === 0 ? (
        <p className="text-mauve">Save pieces you love — they'll live here, waiting.</p>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {items.map(p => (
            <div key={p.id} className="bg-white rounded-[20px] p-3 border border-border">
              <Link to={`/product/${p.slug}`} className="block rounded-xl overflow-hidden aspect-[4/5] bg-blush/40">
                {p.images?.[0] && <img src={p.images[0]} alt={p.name} className="w-full h-full object-cover" />}
              </Link>
              <div className="mt-3 px-1">
                <p className="font-cormorant text-lg">{p.name}</p>
                <p className="font-body text-sm">{formatINR(p.price)}</p>
                <div className="flex gap-2 mt-3">
                  <button className="btn-outline text-[11px] px-4 py-2 flex-1" onClick={() => addItem(p, 1, (p.sizes || [])[0] || null)}>Add to bag</button>
                  <button className="p-2 text-mauve hover:text-rose" onClick={() => remove(p.id)} aria-label="remove"><Trash2 size={15} /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Wishlist;
